<img src="assets/images/vital.png" alt="Vital Banner"/>

<p class="text-center lead">{{ 'pages.updates.certTools.vital.vitalIntro' | translate }}</p>

<form *ngIf="!loadingQuota">
  <div class="row justify-content-center">
      <div class="col-md-6 col-sm-6 col-xs-12 mb-3 mt-3 col align-self-center">

        <ngb-alert 
          *ngIf="vitalQuota <= 0"
          type="info"
          class="mt-4 mb-4">
          You have use all Vital Quota
        </ngb-alert>

        <div class="upload">
          <h1 class="browse">Select a File to upload :</h1>
          <input type="file" name="film" id="file" class="browse" #fileInput (change)="onChange($event)" *ngIf="vitalQuota > 0">
          <span id="file-select-button" class="btn btn-secondary" (click)="triggerFileInputClick()" *ngIf="vitalQuota > 0">{{ 'pages.updates.certTools.vital.chooseAFile' | translate }}</span>
          <span id="file-select-button" class="btn btn-secondary disabled" (click)="triggerFileInputClick()"  *ngIf="vitalQuota == null || vitalQuota <= 0">{{ 'pages.updates.certTools.vital.chooseAFile' | translate }}</span>
          <p class="browse mt-2"><strong>Maximal Size :</strong> 100 Mb</p>
          <p class="browse">All file formats supported</p>
        </div>

        <div class="file" *ngIf="file">
          {{ file?.name}}
        </div>

        <ngb-alert
          *ngIf="scanSuccess === false"
          type="warning"
          [dismissible]="false"
          class="mt-4 mb-5">
          <p class="mb-0">
            <fa-icon [icon]="['fas', 'exclamation-circle']" size="md" data-placement="top" title="waiting icon" class="mr-3"></fa-icon>
            File uploading to Vital failed
          </p>
        </ngb-alert>

      </div>
  </div>

  <div class="d-flex justify-content-center mt-4 mb-1">
    <button class="btn btn-primary disabled" *ngIf="!file">{{ 'pages.updates.certTools.scanFile' | translate }}</button>
    <button class="btn btn-primary" *ngIf="file && !loading" (click)="upload();">{{ 'pages.updates.certTools.scanFile' | translate }}</button>
    <div class="spinner-border text-primary" role="status" *ngIf="file && loading">
      <span class="sr-only">{{ 'pages.generic.loading' | translate }}</span>
    </div>
  </div>
</form>